import type { SVGProps } from "react";
import { cn } from "@hero-app/lib/utils";

export interface IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function Soffi({ className, ...props }: IconProps) {
  return (
    <svg
      role="img"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      {...props}
    >
      <rect width="14" height="14" rx="5" fill="#1C1B1F" />
      <path
        d="M5.75001 9.91671C4.93751 9.91671 4.24827 9.63372 3.6823 9.06775C3.11633 8.50178 2.83334 7.81254 2.83334 7.00004C2.83334 6.18754 3.11633 5.4983 3.6823 4.93233C4.24827 4.36636 4.93751 4.08337 5.75001 4.08337C6.56251 4.08337 7.25175 4.36636 7.81772 4.93233C8.38369 5.4983 8.66668 6.18754 8.66668 7.00004C8.66668 7.81254 8.38369 8.50178 7.81772 9.06775C7.25175 9.63372 6.56251 9.91671 5.75001 9.91671ZM9.29168 9.71879C9.13195 9.77435 8.98786 9.76914 8.85939 9.70317C8.73091 9.63719 8.66668 9.51393 8.66668 9.33337C8.66668 9.25699 8.69272 9.18407 8.7448 9.11462C8.79689 9.04518 8.86112 8.99657 8.93751 8.96879C9.35418 8.8299 9.69098 8.5799 9.94793 8.21879C10.2049 7.85768 10.3333 7.45143 10.3333 7.00004C10.3333 6.54865 10.2049 6.1424 9.94793 5.78129C9.69098 5.42018 9.35418 5.17018 8.93751 5.03129C8.86112 5.00351 8.79689 4.9549 8.7448 4.88546C8.69272 4.81601 8.66668 4.7431 8.66668 4.66671C8.66668 4.4931 8.72918 4.37157 8.85418 4.30212C8.97918 4.23268 9.12154 4.22574 9.28126 4.28129C9.84376 4.48268 10.2986 4.83164 10.6458 5.32817C10.9931 5.82469 11.1667 6.38199 11.1667 7.00004C11.1667 7.6181 10.9931 8.17365 10.6458 8.66671C10.2986 9.15976 9.84723 9.51046 9.29168 9.71879ZM5.75001 9.08337C6.3264 9.08337 6.81772 8.88025 7.22397 8.474C7.63022 8.06775 7.83334 7.57643 7.83334 7.00004C7.83334 6.42365 7.63022 5.93233 7.22397 5.52608C6.81772 5.11983 6.3264 4.91671 5.75001 4.91671C5.17362 4.91671 4.6823 5.11983 4.27605 5.52608C3.8698 5.93233 3.66668 6.42365 3.66668 7.00004C3.66668 7.57643 3.8698 8.06775 4.27605 8.474C4.6823 8.88025 5.17362 9.08337 5.75001 9.08337Z"
        fill="white"
      />
    </svg>
  );
}
